export default "__VITE_ASSET__Q4YaO4VZ__"